import eventLib from './index';
/* 操作全局loading的展示与否 */
export function dispatchLoading(data) {
  eventLib.dispatch('loading', data);
}
/* 触发路由跳转 */
export function dispatchNavigate(path: string | number, extraData?: any) {
  eventLib.dispatch('navigate', path, extraData);
}
